module.exports = __webpack_public_path__ + "img/116.61cc5979.jpg";